module Meevo.Plugins.Register {
    export class TippyBusyModal {
        constructor(private $mdDialog: angular.material.IDialogService) {

        }

        cancel() {
            this.$mdDialog.cancel();
        }

        static $inject = ["$mdDialog"]
    }

    angular.module("meevo.plugins.register")
        .controller("meevo.plugins.register.TippyBusyModal", TippyBusyModal);
}